import React from 'react';
import { func, object } from 'prop-types';
import styled from 'styled-components';
import Icon from '~/modules/components/global/icon';

const Tag = styled.button`
	box-sizing: border-box;
	display: inline-flex;
	align-items: center;
	margin: 0 0.375rem 0.25rem 0;
	border: 1px solid hsl(var(--border));
	border-radius: calc(var(--radius) - 4px);
	background: hsl(var(--secondary));
	padding: 0.375rem 0.5rem;
	line-height: 1;
	color: hsl(var(--foreground));
	font-size: inherit;
	font-weight: 700;

	&::after {
		opacity: 0.75;
		margin-left: 0.5rem;
		color: hsl(var(--muted-foreground));
		content: '\\2715';
	}

	&:hover,
	&:focus {
		outline: 0;
		background: hsl(var(--accent));
	}

	svg {
		flex: 0 0 auto;
		margin-right: 0.5rem;
		width: 0.75rem;
		height: 0.75rem;

		path {
			fill: hsl(var(--foreground));
		}
	}
`;

function IconTag(props) {
	const {
		tag,
		classNames,
		onDelete
	} = props;

	let displayName = tag.label || tag.value.name || tag.value.emailNormal;

	return (

		<span data-tooltip="Click to remove">
			<Tag
				type="button"
				onClick={() => onDelete(tag.value)}
				data-cy="contact-picker-tag"
				className="px-contact-picker-tag"
			>
				<Icon use={tag.icon} />
				<span className={classNames.selectedTagName}>
					{displayName}
				</span>
			</Tag>
		</span>
	);
}

IconTag.propTypes = {
	onDelete: func.isRequired,
	tag: object.isRequired,
	classNames: object.isRequired
};

export default IconTag;
